import { getOperatorsFromOperatorGroup } from './form-elements/operators';

import type { OperatorGroup } from './form-elements/operators';
import type { Attributes, Rule, Schema } from './use-query-builder';

type GetOperatorGroupFromRuleProps = {
  rule: Rule;
  schema?: Schema;
};

export const getOperatorGroupFromRule = ({ rule, schema }: GetOperatorGroupFromRuleProps) => {
  const operatorGroup = schema
    ? schema[rule.Condition]?.attributes?.find((attribute: Attributes) => attribute.name === rule.Attribute)
        ?.operatorGroup
    : 'string';

  const ruleOperators = getOperatorsFromOperatorGroup(operatorGroup as OperatorGroup);
  return ruleOperators;
};

type GetOperatorFromRuleProps = {
  rule: Rule;
  schema?: Schema;
};

export const getOperatorFromRule = ({ rule, schema }: GetOperatorFromRuleProps) => {
  const operatorGroup = getOperatorGroupFromRule({ rule, schema });
  const operator = operatorGroup.find((operator) => operator.name === rule.Operator);
  return operator;
};
